/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getDailyActivityMonitoringLogStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getDailyActivityMonitoringLogStatusByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetDailyActivityMonitoringLogStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getDailyActivityMonitoringLogStatusByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getDailyActivityMonitoringLogStatusByIdPayloadRegExpTwo)]).optional()
});

export type GetDailyActivityMonitoringLogStatusById = zod.input<typeof GetDailyActivityMonitoringLogStatusById>;
export type GetDailyActivityMonitoringLogStatusByIdOutput = zod.output<typeof GetDailyActivityMonitoringLogStatusById>;
